<template>
  <div>
    <!--begin::Header-->
    <div class="card-header border-0 py-5">
      <h3 class="card-title align-items-start flex-column">
        <span class="card-label font-weight-bolder text-dark">
          Payment
        </span>
      </h3>
      <div class="card-toolbar"></div>
      <!--end::Header-->
      <!--begin::Body-->
      <div class="card-body py-0">
        <!--begin::Table-->
        <div class="table-responsive">
          <div v-if="!showBillingWidget">
            <p v-if="products.length > 0">
              <label>Payment</label>
              <b-form-select
                v-model="paymentMethod"
                :options="paymentMethods"
                required
              ></b-form-select>
            </p>
            <p v-if="paymentMethod === 'purchase_order'">
              <label>PO Number</label>
              <b-form-input
                v-model="poNumber"
                placeholder="Your purchase order number, if any."
              >
                <v-icon color="grey lighten-1">mdi-cart</v-icon>
              </b-form-input>
            </p>
            <b-button
              v-if="canOrder"
              v-on:click="orderCampaign()"
              class="full-width"
              variant="primary"
            >
              Order Campaign
            </b-button>
          </div>
          <span v-if="paymentMethod == 'wallet' && !showBillingWidget">
            <p
              class="alert alert-light"
              v-if="
                this.wallet &&
                  this.wallet.balance <
                    this.totalVonqPriceAmountForCurrency(
                      this.wallet.balance.currency
                    )
              "
            >
              Your balance is too low. Add funds to continue ordering.
            </p>
          </span>
          <span
            v-if="
              (paymentMethod == 'purchase_order' ||
                paymentMethod == 'direct_charge') &&
                wallet &&
                wallet.hasBillingDetails == false
            "
          >
            <p class="alert alert-light">
              Before being able to order you need to update your billing
              details.
            </p>
          </span>
          <span v-if="paymentMethod == 'wallet' && !canOrder">
            <p class="alert alert-light">
              Before being able to order you need to top-up your wallet balance.
            </p>
          </span>
          <billing-widget
            v-if="showBillingWidget"
            :wallet="wallet"
            :campaignId="campaignId"
            @payment-success="onPaymentSuccess"
          ></billing-widget>
          <div class="summary-container">
            <wallet
              ref="wallet"
              :amount="amount"
              @wallet-update="payload => (wallet = payload)"
            ></wallet>
            <top-up
              :amount="amount"
              :wallet="wallet"
              @refetch-wallet-needed="onRefetchWalletNeeded"
              v-if="!showBillingWidget"
            ></top-up>
          </div>
        </div>
        <!--end::Table-->
      </div>
      <!--end::Body-->
    </div>
  </div>
</template>

<script>
import { BasketService } from "@/core/services/basket.service";

import Wallet from "@/view/components/checkout/Wallet.vue";
import TopUp from "@/view/components/checkout/TopUp.vue";
import BillingWidget from "@/view/components/checkout/BillingWidget";
import ProductsMixin from "@/view/mixins/ProductsMixin";
import PriceMixin from "@/view/mixins/PriceMixin";
import CurrencyMixin from "@/view/mixins/CurrencyMixin";

export default {
  name: "Payment",
  components: {
    Wallet,
    TopUp,
    BillingWidget
  },
  props: {
    products: {
      type: Array,
      required: true
    }
  },
  mixins: [ProductsMixin, PriceMixin, CurrencyMixin],
  emits: ["instant-billing-success", "ordercampaign"],
  data() {
    return {
      poNumber: null,
      displayOptions: {},
      wallet: null,
      paymentMethod: null,
      paymentMethods: [
        { value: null, text: "Please select", selected: true },
        {
          value: "direct_charge",
          text: "Pay Now (I have credit card or bank account details)"
        },
        {
          value: "purchase_order",
          text: "Purchase Order (invoice me and I'll pay later)"
        },
        {
          value: "wallet",
          text: "Wallet Balance (use existing balance in my account)"
        },
        {
          value: "ats_managed",
          text: "ATS Managed (the ATS manages payment for me)"
        }
      ],
      campaignId: null,
      showBillingWidget: false
    };
  },
  computed: {
    amount() {
      return this.totalVonqPriceAmount > this.wallet?.balance.amount
        ? Math.floor(
            this.totalVonqPriceAmountForCurrency(
              this.wallet?.balance.currency
            ) * 100
          )
        : "";
    },
    canOrder() {
      const hasProductsInBasket = this.products.length > 0;
      const isAtsManaged = this.paymentMethod == "ats_managed";
      const canOrderDirectCharge =
        this.paymentMethod == "direct_charge" && this.wallet?.hasBillingDetails;
      this.paymentMethod == "wallet" &&
        this.wallet?.balance.amount >=
          this.totalVonqPriceAmountForCurrency(this.wallet?.balance.currency);
      const canOrderWithWallet =
        this.paymentMethod == "wallet" &&
        this.wallet?.hasBillingDetails &&
        this.wallet?.balance.amount >=
          this.totalVonqPriceAmountForCurrency(this.wallet?.balance.currency);
      const canOrderWithPurchaseOrder =
        this.paymentMethod == "purchase_order" &&
        this.wallet?.hasBillingDetails;
      return (
        hasProductsInBasket &&
        (isAtsManaged ||
          canOrderDirectCharge ||
          canOrderWithWallet ||
          canOrderWithPurchaseOrder) &&
        !this.showBillingWidget
      );
    },
    shouldTopUp() {
      return (
        this.wallet?.balance.amount >=
        this.totalVonqPriceAmountForCurrency(this.wallet?.balance.currency)
      );
    }
  },
  methods: {
    async orderCampaign() {
      await this.$refs.wallet.fetchWallet();
      if (this.canOrder) {
        this.$emit(
          "ordercampaign",
          this.paymentMethod,
          this.wallet?.id,
          this.poNumber
        );
      }
    },
    onPaymentSuccess() {
      this.$emit("instant-billing-success");
    },
    async fetchWallet() {
      return await this.$refs.wallet.fetchWallet();
    },
    async onRefetchWalletNeeded() {
      await this.$refs.wallet.fetchWallet();
    },
    showBillingWidgetForCampaign(data) {
      this.campaignId = data.campaignId;
      this.showBillingWidget = true;
    }
  },
  mounted() {
    this.displayOptions = BasketService.getDisplayOptions();
  },
  created: function() {
    window.addEventListener("message", this.onWindowMessage);
  },
  destroyed: function() {
    window.removeEventListener("message", this.onWindowMessage);
  }
};
</script>

<style scoped>
.full-width {
  width: 100%;
}

.payment-iframe {
  width: 100%;
  height: 600px;
  border: none;
  margin-top: 10px;
}

.summary-container {
  text-align: right;
  padding: 10px;
}
</style>
